/* import __COLOCATED_TEMPLATE__ from './disable-end-user-follow-up-replies.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();